import { Component, OnInit, isDevMode } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { BroadcastService } from '../../../../services/broadcast.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { CountriesService } from '../../../../services/countries.service';
import { AppConfig } from '../../../../app.config';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-shop-profile',
  templateUrl: './shop-profile.component.html',
  styleUrls: ['./shop-profile.component.scss'],
  providers: [MessageService],
})
export class ShopProfileComponent implements OnInit {
  public partnerId: any;
  public partner: any = {};
  public ShopForm: FormGroup;
  public busy: boolean = false;
  public workflowItems: any = [
    { label: 'Select a workflow', value: 0 },
    { label: 'Hubtiger Job Card Workflow', value: 1 },
    { label: 'Manual Jobcard Workflow', value: 2 },
    { label: 'Hubtiger QA Sheet Only', value: 3 },
  ];
  public units: any = this.appConfig.getUnits();
  public countries = []; //this.appConfig.getSupportedCountries();
  public timeZones = []; //this.appConfig.getSupportedCountries();
  public fallBackImage = '';
  public isDev: boolean = false;
  public isSuperUser: boolean = false;
  public partnerTypes: any = {};
  public isRentals = false;
  public isWorkshop = true;

  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private countriesService: CountriesService,
    private broadcastService: BroadcastService,
    private translate: TranslateService,
    private router: Router
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
    this.isDev = isDevMode();
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/shop-profile'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }

    this.getPartnerData();
    this.countriesService.getAllCountries().subscribe((countries) => {
      this.countries = countries.map((x) => {
        return { ...x, label: x.country, value: x.code };
      });
    });
    this.isSuperUser = this.helpersService.getProfileData().IsSuperUser;
    this.partnerTypes = this.appConfig.getPartnerTypes();
    this.getTimezones();
  }

  getPartnerData() {
    this.partnerService
      .getPartnerDetail(this.partnerId)
      .subscribe((partner) => {
        this.partner = partner;
        console.log(this.partner);
        this.setupValidation();
        if (!this.partner.PartnerImage) {
          this.fallBackImage =
            'https://' +
            (isDevMode() ? 'hubtigerdev' : 'hubtiger') +
            '.blob.core.windows.net/partners/partnerlogo_' +
            this.partnerId +
            '.jpeg';
          this.partnerService.testURL(this.fallBackImage).subscribe(
            (res) => { },
            (err) => {
              this.fallBackImage = null;
            },
          );
        }
      });
  }

  setupValidation() {
    this.ShopForm = this.fb.group({
      Name: new FormControl(this.partner.Name, Validators.required),
      Description: new FormControl(
        this.partner.Description,
        Validators.nullValidator,
      ),
      PhoneNumber1: new FormControl(
        this.partner.PhoneNumber1,
        Validators.required,
      ),
      PhysicalAddress: new FormControl(
        this.partner.PhysicalAddress,
        Validators.nullValidator,
      ),
      WebAddress: new FormControl(
        this.partner.WebAddress,
        Validators.nullValidator,
      ),
      eMail: new FormControl(this.partner.eMail, Validators.email),
      Country: new FormControl(this.partner.Country, Validators.required),
      CurrencySymbol: new FormControl(
        this.partner.CurrencySymbol,
        Validators.required,
      ),
      OffersBookingService: new FormControl(
        this.partner.OffersBookingService,
        Validators.required,
      ),
      OffersFittingService: new FormControl(
        this.partner.OffersFittingService,
        Validators.required,
      ),
      WorkflowTypeID: new FormControl(
        this.partner.WorkflowTypeID,
        Validators.nullValidator,
      ),
      MinimumJobcardNo: new FormControl(
        this.partner.MinimumJobcardNo,
        Validators.required,
      ),
      VATRate: new FormControl(this.partner.VATRate * 100, [
        Validators.required,
        Validators.max(100),
        Validators.min(0),
      ]),
      VATInclusive: new FormControl(
        this.partner.VATInclusive,
        Validators.nullValidator,
      ),
      ShowZeroTaxAmounts: new FormControl(
        this.partner.ShowZeroTaxAmounts,
        Validators.nullValidator,
      ),
      DefaultUnitOfMeasure: new FormControl(
        this.partner.DefaultUnitOfMeasure,
        Validators.nullValidator,
      ),
      //'EnableCustomerMessaging': new FormControl(this.partner.EnableCustomerMessaging, Validators.nullValidator)
      AllowDiscount: new FormControl(
        this.partner.AllowDiscount || false,
        Validators.nullValidator,
      ),
      ShowGDPRMarketingConsent: new FormControl(
        this.partner.ShowGDPRMarketingConsent || false,
        Validators.nullValidator,
      ),
      ShowGDPRMarketingConsentCustomText: new FormControl(
        this.partner.ShowGDPRMarketingConsentCustomText || '',
        Validators.nullValidator,
      ),
      Enable2FA: new FormControl(
        this.partner.Enable2FA || false,
        Validators.nullValidator,
      ),
      ReviewTrustPilotUrl: new FormControl(
        this.partner.ReviewTrustPilotUrl || '',
        Validators.nullValidator,
      ),
      ReviewGoogleUrl: new FormControl(
        this.partner.ReviewGoogleUrl || '',
        Validators.nullValidator,
      ),
      SendNotificationOnBooking: new FormControl(
        this.partner.SendNotificationOnBooking || false,
        Validators.nullValidator,
      ),
      ReminderHoursBeforeService: new FormControl(
        this.partner.ReminderHoursBeforeService,
        [Validators.required, Validators.max(72), Validators.min(12)],
      ),
      ServiceFollowUpReminderMonths: new FormControl(
        this.partner.ServiceFollowUpReminderMonths || 6,
        [Validators.required, Validators.max(24), Validators.min(1)],
      ),
      Print_ShowLogo: new FormControl(
        this.partner.Print_ShowLogo || false,
        Validators.nullValidator,
      ),
      Print_ShowChecklist: new FormControl(
        this.partner.Print_ShowChecklist || false,
        Validators.nullValidator,
      ),
      Print_ShowQuote: new FormControl(
        this.partner.Print_ShowQuote || false,
        Validators.nullValidator,
      ),
      PartnerType: new FormControl(
        this.partner.PartnerType || 1,
        Validators.required,
      ),
      FreeTextMergeTag: new FormControl(
        this.partner.FreeTextMergeTag || false,
        Validators.nullValidator,
      ),
      Project529Enabled: new FormControl(
        this.partner.Project529Enabled || false,
        Validators.nullValidator,
      ),
      TimeZone: new FormControl(this.partner.Timezone),
    });
    if (
      this.partner.POSSystemID === 6 ||
      this.partner.POSSystemID === 3 ||
      this.partner.POSSystemID === 8 ||
      this.partner.POSSystemID === 9 ||
      this.partner.POSSystemID === 11 ||
      this.partner.POSSystemID === 12 ||
      this.partner.POSSystemID === 19 ||
      this.partner.POSSystemID === 20 ||
      this.partner.POSSystemID <= 0
    ) {
      this.ShopForm.controls['AllowDiscount'].enable();
    } else {
      this.ShopForm.controls['AllowDiscount'].disable();
    }
  }

  savePartner(partner) {
    this.busy = true;
    let update = {
      ...this.partner,
      ...partner,
      VATRate: partner.VATRate / 100,
    };
    this.partnerService.savePartnerDetail(update).subscribe((partner) => {
      this.helpersService.savePartnerData(partner);
      this.busy = false;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.shop_profile.message_profile_updates',
        ),
      });
      this.broadcastService.sendMessage({
        partner: {
          switchPartner: {},
        },
      });
    });
  }

  updateLogo(event) {
    this.busy = true;
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onload = (file: any) => {
      let data = {
        Image: file.target.result,
        Folder: 'partnerphotos',
        Type: 'PartnerLogo',
      };
      this.partnerService
        .uploadImage(data, this.partnerId)
        .subscribe((result) => {
          this.partner.ImageURL = result;
          this.helpersService.savePartnerData(this.partner);

          this.busy = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.shop_profile.message_profile_photo_updated',
            ),
          });
          //this.broadcastService.sendMessage({profile: user});
        });
    };
  }

  updatePhoto(event) {
    this.busy = true;
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onload = (file: any) => {
      let data = {
        Image: file.target.result,
        Folder: 'partnerphotos',
        Type: 'PartnerImage',
      };
      this.partnerService
        .uploadImage(data, this.partnerId)
        .subscribe((result) => {
          this.partner.PartnerImage = result;
          this.helpersService.savePartnerData(this.partner);

          this.busy = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.shop_profile.message_profile_photo_updated',
            ),
          });
          //this.broadcastService.sendMessage({profile: user});
        });
    };
  }

  getTimezones() {
    var aryIanaTimeZones = Intl.supportedValuesOf('timeZone');

    let date = new Date;
    aryIanaTimeZones.forEach((timeZone) => {
      //console.log(timeZone, this.getTimezoneOffset(timeZone))
      var offset = this.getTimezoneOffset(timeZone);
      this.timeZones.push({
        label: timeZone + ' ( ' + (offset) + ' )',
        value: timeZone + '|' + offset,
      });
    });
  }

  getTimezoneOffset(timeZone) {
    const now = new Date();
    const tzString = now.toLocaleString('en-US', { timeZone });
    const localString = now.toLocaleString('en-US');
    const diff = (Date.parse(localString) - Date.parse(tzString)) / 3600000;
    const offset = diff + now.getTimezoneOffset() / 60;

    return -offset;
  }

  saveTimezone() {
    this.busy = true;
    let timezone = this.ShopForm.get('TimeZone').value;
    console.log(timezone);
    var obj: any = { "Property": "Timezone", "Value": timezone };
    console.log(obj);
    this.partnerService.savePartnerDetails(obj).subscribe((partner) => {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.shop_profile.message_profile_updates',
        ),
      });
    });
  }
}
